
import { List, NavBar, Tabs } from 'antd-mobile'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { init, dispose } from 'klinecharts'

import { 
    BodyView,
    ListView,
    NavBarTitleView,
    CoinHeaderView,
    TabsView,
    EllipsisView,
    LoadView,
    DividerTrendView,
    PopupSelectView
} from "../factory/ViewUtil";

import { FavoritesIcon, FavoritesOKIcon, MoreR4Icon } from "../icons";

import { CellFourRowView, CellHeaderView, CellLastPriceView, CellStateView } from "../factory/CellViews";
import { isLogin, RequestMarketTrade, RequsetKline } from "../../NetworkFactory";
import { DecimalConvert, FullURL, ToDate3 } from '../factory/FactoryUtil';
import { DoFavorite } from '../market/FavoritesManager';


// # k显示周期
const tabItems = [
    { key: 'MIN1', title: '1Min' },
    { key: 'MIN5', title: '5Min' },
    { key: 'MIN30', title: '30Min' },
    { key: 'MIN60', title: '1Hour' },
    { key: 'DAY1', title: '1Day' },
    { key: 'WEEK1', title: '1Week' }
]

const TrendViewController = ({gohome, goback, navpush, data}) => {

    const [symbol, setSymbol] = useState(data.symbol || '');
    const [symbolData, setSymbolData] = useState(data);

    const [stateCode, setStateCode] = useState(3);
    const [dataSource, setDataSource] = useState([]);

    const [chartView, setChartView] = useState(null);
    const [isLoading, setLoading] = useState(true);
    
    const [marketData, setMarketData] = useState([]);
    const [visiblePopup, setVisiblePopup] = useState(false);
    const [timeInterval, setTimeInterval] = useState(tabItems[0].key);

    const borderColor = '#F6F6F6';

    const orderSleep = 5000
    const klineSleep = 3000

    //=========================================================
    // # 刷新k线
    const timeoutKlineRef = useRef(null);
    const clearKlineTimeout = () => {
        clearTimeout(timeoutKlineRef.current)
        timeoutKlineRef.current = null
    }
    const refreshKlineData = () => {
        clearKlineTimeout()
        const isUpdate = chartView.getDataList().length > 0
        RequsetKline(symbol, timeInterval, isUpdate).then(response => {
            const result = response.data
            if(!isUpdate) {
                let data = []
                let kline = result.kline
                for(const item in kline) {
                    let value = kline[item]
                    data.push( { 
                        close: value.close,
                        high: value.high, 
                        low: value.low, 
                        open: value.open, 
                        timestamp: parseInt(value.id + '000'), 
                        volume: value.vol,
                        amount : value.amount
                    })
                }
                chartView.clearData()
                chartView.applyNewData([...data].reverse(), true)
                setLoading(false)
            }
            else {
                let kline = result.kline
                let data = { 
                    close: kline.close,
                    high: kline.high, 
                    low: kline.low, 
                    open: kline.open, 
                    timestamp: parseInt(kline.id + '000'), 
                    volume: kline.vol,
                    amount : kline.amount
                }
                chartView.updateData(data)
            }

            // # 执行
            const id = setTimeout(() => {
                refreshKlineData()
            }, klineSleep);
            timeoutKlineRef.current = id;
        })
    }
    //=========================================================

    // # 更新符号
    //=========================================================
    const updateSymbol = (val) => {
        setVisiblePopup(false)
        setSymbol(val)
    }
    //=========================================================

    //=========================================================
    // # 初始化k线视图
    useEffect(() => {
        if(symbol === undefined) {
            gohome()
            return
        }
        const chart = init('chart');
        chart.setStyles({
            grid: {horizontal: {style : 'solid', color : borderColor }, vertical: { style : 'solid', color : borderColor}},
            candle : {tooltip : {showRule : 'follow_cross', showType : 'rect',
                    custom : (data) => {
                        return [
                            { title: 'Time: ',  value: '{time}' }, 
                            { title: 'Open: ',    value: '{open}' }, 
                            { title: 'Hight: ',    value: '{high}' },
                            { title: 'Low: ',    value: '{low}' },
                            { title: 'Close: ',    value: '{close}' },
                            { title: 'Amount: ',    value: DecimalConvert(data.current.amount) + '' }
                        ]
                    },
                    rect : {
                        borderSize: 0,
                        color : 'rgba(0, 0, 0, 0.76)'
                    },
                    text : {
                        color : '#FFFFFF'
                    }
                }
            },
            indicator : {tooltip : { showName : false } },
            yAxis : {inside : true, axisLine : { show : false }},
            xAxis : {axisLine : { show : true, color : borderColor }, tickLine : {length : 0}},
            separator : {color : borderColor, fill: false},
        })
        chart.createIndicator({ name : 'MA', calcParams : [5, 10, 30]}, true, { id: 'candle_pane', dragEnabled: false,  gap : {top : 60}, height: 60, axisOptions: {  scrollZoomEnabled: false } })
        chart.createIndicator({ name : 'VOL', calcParams : [5, 10]}, true, { dragEnabled: false, height: 60, axisOptions: { scrollZoomEnabled: false } })
        chart.createIndicator({ name : 'MACD'},  true, { dragEnabled: false, height: 60, axisOptions: { scrollZoomEnabled: false } })
        chart.zoomAtCoordinate(1)
        setChartView(chart)
        return () => {
            dispose('chart')
        }
    }, []);  // eslint-disable-line react-hooks/exhaustive-deps
    //=========================================================

    // # 监听变化刷新k线
    useEffect(() => {
        if(chartView) {
            chartView.clearData()
            setLoading(true)
            refreshKlineData()
        }
    }, [chartView, symbol, timeInterval]) // eslint-disable-line react-hooks/exhaustive-deps
    //=========================================================
    
    //=========================================================
    // # 监听币种市场信息变化
    useEffect(() => {
        if(symbol.length > 0) {
            for(let i = 0; i<marketData.length;i++) {
                const item = marketData[i]
                if(item.symbol === symbol) {
                    setSymbolData({...item})
                    break
                }
            }
        }
    }, [symbol, marketData]) // eslint-disable-line react-hooks/exhaustive-deps
    //=========================================================

    //=========================================================
    // # 交易数据
    const timeoutOrderRef = useRef(null);
    const clearOrderTimeout = () => {
        clearTimeout(timeoutOrderRef.current)
        timeoutOrderRef.current = null
    }
    const requestOrderData = useCallback(() => {
        clearOrderTimeout()
        RequestMarketTrade(symbol).then(response => {
            const data = response.data || []
            setStateCode(data.length >0 ? -1 : 3)
            setDataSource(data)

            const id = setTimeout(() => {
                requestOrderData()
            }, orderSleep);
            timeoutOrderRef.current = id;
        }).catch(() => {
            setStateCode(1)
        })
    }, [symbol]) // eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => {
        if(symbol.length > 0) {
            
            setStateCode(3)
            setDataSource([])

            requestOrderData()
        }
        return () => {
            clearOrderTimeout()
            clearKlineTimeout()
        }
    }, [symbol]) // eslint-disable-line react-hooks/exhaustive-deps
    //=========================================================

    //=========================================================
    // # 市场信息
    useEffect(() => {
        React.ListenerCandlestickDataSource('TrendViewController', (data) => {
            setMarketData(data)
        });
        // # componentWillUnmount
        return () => {
            React.ListenerCandlestickRemove('TrendViewController')
        }
    }, []);  // eslint-disable-line react-hooks/exhaustive-deps
    //=========================================================

    // # 关注符号
    const [followed, setFollowed] = useState(false);
    useEffect(() => {
        if(isLogin()) {
            setFollowed(symbolData.isFollowed === true)
        }
    }, [symbolData]) // eslint-disable-line react-hooks/exhaustive-deps

    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>
                    <NavBarTitleView onClick={()=>{setVisiblePopup(true)}} src={FullURL(symbolData.logo)} icon={<MoreR4Icon/>}>{symbol}</NavBarTitleView>
                </NavBar>
            </div>
            <BodyView style={{padding: '52px 0 80px 0'}}>
                <ListView>
                    <List.Item style={{marginTop : '10px'}}>
                        <CoinHeaderView item={symbolData}/>
                    </List.Item>
                    <List.Item style={{margin : '10px 0'}}>
                        <TabsView fontSize='14px' onChange={(key)=>{setTimeInterval(key)}} activeKey={timeInterval}>
                            {tabItems.map(item => (
                                <Tabs.Tab title={item.title} key={item.key} />
                            ))}
                        </TabsView>
                    </List.Item>
                    <List.Item>
                        <div style={{position : 'relative'}}>
                            <div id="chart" style={{height : '360px', borderRadius : '6px', border : `1px ${borderColor} solid`}}></div>
                            {
                                isLoading ? (<div style={{
                                    position : 'absolute', 
                                    left : '0', 
                                    top : '0', 
                                    width : '100%',
                                    height : '360px', 
                                    background : '#FFF', 
                                    zIndex : '2',
                                    display : 'flex',
                                    alignItems: 'center',
                                    justifyContent : 'center'
                                }}>
                                    <LoadView src={FullURL(symbolData.logo)}/>
                                </div>) : ''
                            }
                        </div>
                    </List.Item>

                    <CellHeaderView>Open order list</CellHeaderView>
                    <CellFourRowView
                            style = {{marginBottom : '10px', color : '#B0B0B0'}}
                            value_1='Time' 
                            value_2='Type'
                            value_3='Price'
                            value_4='Amount'/>

                    <CellStateView stateType={stateCode} onRefresh={requestOrderData}/> 
                    {
                        dataSource.map((item, index) => (
                            <CellFourRowView
                                style = {{marginBottom : '8px'}}
                                key = {index}
                                value_1={ToDate3(item.ts)}
                                value_2={<b style={{color : (item.direction).toLowerCase() === 'sell' ? '#F0495B' : '#08BF89'}}>{item.direction}</b>}
                                value_3={<EllipsisView content={item.price + ''}/>} 
                                value_4={<EllipsisView content={item.amount +''}/>}/>
                        ))
                    }
                </ListView>
            </BodyView>
            
            <div className="fixed-tab-bar" style={{textAlign : 'center', padding : '15px 0', display: 'flex', alignItems : 'center'}}>
                <div style={{width : '15px'}}></div>
                <div onClick={()=>{navpush('/trade')}} style={{width : '100%'}}><DividerTrendView/></div>
                <div style={{width : '15px'}}></div>
                <div onClick={()=>{DoFavorite(symbol)}}>
                    <div style={{marginBottom : '2px'}}>
                        {followed ? <FavoritesOKIcon/> : <FavoritesIcon/>}
                    </div>
                    <div style={{color : '#9B9B9B', fontSize : '12px'}}>Favorites</div>
                </div>
                <div style={{width : '15px'}}></div>
            </div>

            <PopupSelectView visible={visiblePopup} close={()=>{setVisiblePopup(false)}}>
                {
                    marketData.map((item, index) => (
                        <CellLastPriceView
                            item={item}
                            key={index} 
                            onClick={()=>{updateSymbol(item.symbol)}}
                            avatar={true}/>
                    ))
                }
            </PopupSelectView>
        </>
    );
}
export default React.memo(TrendViewController)